import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { mfaVerify, sendMfaCode } from "../../actions/loginActions"; 
import { useNavigate } from "react-router-dom";
import { TOAST_ERROR } from "../../utils";

function MFALogin({mfaCollabratorToken='', isCollabrator=false, updateSelectedCollabrator}){
    const [mfaCode, setMfaCode] = useState('');
    const [useMfaCode, setUseMfaCode] = useState(false);
    const dispatch = useDispatch();
    const history = useNavigate();
    
    const handleSubmit = () => {
        if(mfaCode && mfaCode.length > 0){
            if (!useMfaCode && (!/^\d{6}$/.test(mfaCode))) {
                TOAST_ERROR('Please enter a valid MFA Code');
            } else if(useMfaCode && mfaCode.length < 25) TOAST_ERROR('Please enter a valid Backup Code');
            else{
                const payload = {otp: mfaCode, mfa_token: mfaCollabratorToken || localStorage.getItem('mfa_token') || ''};
                dispatch(mfaVerify(payload, history, isCollabrator, updateSelectedCollabrator));
            }
        }
    }

    const sendMailMfaCode = () => sendMfaCode({mfa_token: localStorage.getItem('mfa_token') || ''});
    
    useEffect(() => {
        const mfaToken = localStorage.getItem('mfa_token');
        if (!mfaToken && !isCollabrator) history('/login');
    }, [history]);

    return(
        <div className="loginFormSec formControlMin mfaLogin">
            <div className="mfaBlock py-5">
                <div className="mfaHead mb-5">
                    <h3 className="mb-3">Additional verification required</h3>
                    <p className="mb-2">Your account is protected with <strong className="text-dark">Multi-Factor Authentication (MFA).</strong></p>
                    <p>To complete the Sign In Process, please enter the code generated by your authenticator app below.</p>
                </div>
                <div className="">
                    <div className="form-group labelPosition mb-2">
                        <label htmlFor="AccountEmailId">{useMfaCode? 'Backup' : 'MFA'} Code</label>
                        <input name="mfaCode" autoComplete={'off'} className={`form-control`} placeholder="Enter backup code" type="text" id="mfaCode" onChange={e => setMfaCode(e.target.value)} value={mfaCode} maxLength={50}/>
                        
                    </div>

                     
                        <div className="form-group f-between mb-4">
                            <p>{useMfaCode ? 'Backup' : 'MFA'}  Code not working? <Button variant="" className="p-0 text-dark border-0 btnSignUp" onClick={() => { setUseMfaCode(!useMfaCode); setMfaCode('')}}>{useMfaCode ? 'Use MFA Code' : 'Use Backup Code'}</Button></p>
                            { !isCollabrator && useMfaCode ? <p><Button variant="" className="p-0 link-primary border-0 btnSignUp" onClick={() => sendMailMfaCode()}>Still Having Troubles?</Button></p> : null}
                        </div>
                     
                    
                    <div className="form-group">
                        <Button variant="primary" className={`w-100`} data-style="expand-left" disabled={mfaCode.length < 6} onClick={handleSubmit}>
                        Submit
                        </Button>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default MFALogin;